<template>
    <div>
        <div class="title_text">
            <div>
                <Icon type="ios-bookmark" size="18" color="#0466dd" />
                <span class="title_text2">项目需求</span>
            </div>
            <div class="query_box">
                <span class="create_time_txt">
                    更新时间： {{ requirement_data.update_time }}
                </span>

            </div>
        </div>

        <div class="data_div">

            <div class="card_main">
                <div class="count_card" @click="click_week_count()">
                    <div>
                        <CountUp :end="requirement_data.week_count" :duration="4" v-font="22" />
                    </div>
                    <div class="count_title">
                        周需求
                    </div>
                </div>

            </div>
        </div>

        <Modal v-model="count_show" title="周需求更新" :footer-hide="true" width="300">
            <div class="people_count_div">
                <span>需求人数：</span>
                <InputNumber v-model="update_week_count" :min="0" />
            </div>
            <div class="need_button_div">
                <Button type="primary" style="font-size:12px" @click="update_need_data">确认更新</Button>
            </div>
        </Modal>


    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: "requirement_data",
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            project_id: "",
            project_name: "",
            query_date: [],
            requirement_data: {
                week_count: 0,
                update_time: ''
            },
            update_week_count: 0,

            count_show: false,

        }
    },

    methods() {


    },
    methods: {

        click_week_count() {
            this.count_show = true
            this.update_week_count = this.requirement_data.week_count
        },



        open(project_id, project_name) {
            this.project_id = project_id
            this.project_name = project_name


            this.get_need_data()
        },

        //需求数据
        get_need_data() {
            var that = this
            var obj = {
                project_id: this.project_id,

            }
            http("post", process.env.VUE_APP_HOST + "/my_project/project_detail/need_data/week_need", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.requirement_data.week_count = res.data.week_count
                        that.requirement_data.update_time = res.data.update_time
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        //需求数据更新
        update_need_data() {
            var that = this
            var obj = {
                project_id: this.project_id,
                count: this.update_week_count
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/project_detail/need_data/week_need_update", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.get_need_data()
                        that.count_show = false;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },



    }

}
</script>

<style scoped>
.need_button_div {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px
}

.create_time_txt {
    letter-spacing: 0px;
    font-size: 13px;
    margin-right: 10px;
    font-weight: 300;
}

.export_div {
    padding-top: 5px;
    align-items: center;
    display: flex;
    font-size: 13px;
    justify-content: flex-end;
    cursor: pointer;
    color: #0466dd
}

.ratiospan {
    font-size: 18px;
    position: absolute;
    right: 20px;
    top: 8px;
}

.title_text2 {
    font-weight: 600;

}

.export_table {
    font-size: 12px;
    color: #0466dd;
    font-weight: 300;
    margin-right: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    letter-spacing: 1px
}

.people_count_div {
    display: flex;
    align-items: center;
}

.title_text {
    margin: 0px 10px 0 10px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #ddd;
    padding: 10px 10px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    letter-spacing: 2px
}

.count_title3 {
    font-size: 13px;
    color: #0d35c4;
    margin-top: 5px;
}

.card_main {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}

.count_title {
    font-size: 13px;
    color: #333;
    margin-top: 5px;
}


.count_title2 {
    font-size: 13px;
    color: #fff;
    margin-top: 5px;
}

.count_card {
    position: relative;
    margin: 0 10px 10px 0;
    cursor: pointer;
    padding: 5px 10px 10px 10px;
    width: 130px;
    border-radius: 5px;
    background-color: #fff;
    text-align: center;
}

.count_card2 {
    position: relative;
    margin: 0 10px 10px 0;
    cursor: pointer;
    padding: 5px 10px 10px 10px;
    width: 130px;
    border-radius: 5px;
    color: #fff;
    background-color: rgb(89, 146, 220);
    text-align: center;
}


.count_card3 {
    position: relative;
    margin: 0 10px 10px 0;
    cursor: pointer;
    padding: 5px 10px 10px 10px;
    width: 130px;
    border-radius: 5px;
    color: #fff;
    background-color: rgb(248, 73, 47);
    text-align: center;
}

.data_div {
    padding: 10px;
    border-radius: 5px;
}

.query_box {
    display: flex;
    justify-content: flex-end;
}
</style>